import React, { useState, useEffect, Fragment } from 'react';
import { BrowserRouter as Router, Switch, Route, Link, useHistory, Redirect, useLocation, useParams } from "react-router-dom";
import "antd/dist/antd.min.css";
import './index.scss';
import { useForm } from "react-hook-form";
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from "react-redux";
import { useGetStoreDealsQuery } from '../../services/search';
import Skeleton from '@material-ui/lab/Skeleton';
import { addProductImg } from "../../Reducers/authReducer";
import Loader from '../../Components/Loader';
import Button from '@mui/joy/Button';
import IconButton from '@mui/joy/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import GradeIcon from '@mui/icons-material/Grade';
import SearchLoader from '../../Components/SearchLoader';
import { useGetUserDataQuery } from '../../services/login';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import formatPrice from '../../Components/formatPrice';
import ProductCountries from '../../Components/Header/ProductCountries';
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined';
import SeacrhFilter from '../../Components/SeacrhFilter';
import GetFilterCountries from '../../Components/GetFilterCountries';
import { useMediaQuery } from 'react-responsive'
import LoadMoreSkeleton from '../../Components/LoadMoreSkeleton';
import { Helmet } from 'react-helmet';
import Host from '../../Components/Host';
import FlashOnIcon from '@mui/icons-material/FlashOn';

function StoreDeals() {
  const { userId, userToken, userEmail, languageCode, countryCode } = useSelector((state) => state.auth);
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation()
  const dispatch = useDispatch();
  const { query } = useParams();
  const { register: register2, handleSubmit: handleSubmit2, formState: { errors: errors2 }, reset: reset2 } = useForm();
  const search = new URLSearchParams(location.search).get('search') || null
  const thisSearch = search ? `&search=${search}` : ''
  const searchCountry = new URLSearchParams(location.search).get('country') || null
  const thisCountry = searchCountry ? `&search_country=${searchCountry}` : ''
  const searchbrand = new URLSearchParams(location.search).get('brand') || null
  const thisBrand = searchbrand ? `&brand=${searchbrand}` : ''
  const limit = new URLSearchParams(location.search).get('size') || 48

  const isMobcreen2 = useMediaQuery({ query: '(min-width: 0px) and (max-width: 992px)' })
  const isMobcreen = useMediaQuery({ query: '(min-width: 0px) and (max-width: 768px)' })
  const { data: userData } = useGetUserDataQuery({ userId: userId, userToken: userToken, countryCode: countryCode }, { count: 1 }, { refetchOnMountOrArgChange: true })

  const [getProducts, setProductsData] = useState([]);
  const [getPage, setPage] = useState(1);
  const [getSearchId, setSearchId] = useState(0);

  const [getNextCursor, setNextCursor] = useState(0);

  // const lastId = getProducts?.slice(-1)[0]?.id || 0;

  const { data: newPosts = [], isLoading, isError, isFetching } = useGetStoreDealsQuery({
    page: getPage,
    size: limit,
    nextCursor: `&nextCursor=${getNextCursor}`,
    query: query,
    search: thisSearch,
    search_id: `&search_id=${getSearchId}`,
    countryCode: countryCode,
    searchCountry: thisCountry,
    searchBrand: thisBrand
  }, { count: 1 }, { refetchOnMountOrArgChange: true })
  const products = newPosts?.results
  const pagination = newPosts?.pagination


  // useEffect(() => {
  //   if (products?.length) {
  //     if (getPage === 1) {
  //       setProductsData(products);
  //     } else {
  //       setProductsData((prev) => [...prev, ...products]);
  //     }
  //   }
  // }, [products]);

  // useEffect(() => {
  //   setProductsData([]);
  //   setPage(1);
  //   setSearchId(0);
  // }, [query, thisSearch, thisCountry, thisBrand]);

  // const loadMore = () => {
  //   setSearchId(lastId);
  //   setPage((prevPage) => prevPage + 1);
  // };



  React.useEffect(() => {
    if (products?.length > 0) {
      setProductsData((prevPosts) => [...prevPosts, ...products]);
    }
  }, [newPosts]);


  useEffect(() => {
    if (products) {
      setProductsData(() => [...products]);
      setPage(1)
    }
  }, [query, search, searchCountry]);


  useEffect(() => {
    if (Number(getPage) === 1 && products) {
      setProductsData((prevPosts) => [...products]);
    }
  }, [getPage, products]);


  useEffect(() => {
    if (Number(getPage) === 1 && isFetching) {
      setProductsData((prevPosts) => []);
    }
  }, [getPage, query, search, searchCountry]);


  const lastId = getProducts?.slice(-1)[0]?.id || 0;

  const loadMore = () => {
    setPage((prevPage) => prevPage + 1);
    setSearchId(lastId)
    setNextCursor(pagination?.nextCursor)
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      // behavior: "smooth"
    });
  }, [])

  function productTitle(title) {
    return title?.replace(/[^A-Za-z0-9]/g, ' ')?.replace(/[^\w\s]/gi, ' ')?.replace(/ /g, '-')
  }

  function addProductImage(data) {
    dispatch(addProductImg({ productImg: data }));
  }
  const handleError = (e) => {
    console.error('Error loading image:', e.target.src);
    e.target.src = 'https://cdn.ebtida.com/1705315901965-Image-not-found.jpg';
  };

  const beforeLoadHandler = () => (
    <img
      className="img-item"
      src='https://cdn.ebtida.com/1705315901965-Image-not-found.jpg' />
  );

  function ratingFucn(rating) {
    if (rating === 0) {
      return false
    } else if (rating === '0') {
      return false
    } else if (!rating) {
      return false
    } else {
      return true
    }
  }
  function loadFetch() {
    if (isLoading) {
      return true
    } else if (isFetching) {
      return true
    } else {
      return false
    }
  }

  const storIds = [1, 3, 18, 19, 20, 21, 22, 25, 11, 12]
  function functionIdLink(id, pid, store_id) {
    if (storIds?.includes(Number(store_id))) {
      return pid
    } else {
      return id
    }
  }


  function searchOrder(data) {
    const result = data?.orderId;
    history.push(`${window.location.pathname}?search=${result}`)
  }

  function clearSearch() {
    reset2()
    history.push(`${window.location.pathname}`)
  }

  function loadCountrySkeleton(fetch, country, itemCountry) {
    if (!country) {
      return false
    }
    if (fetch && country != itemCountry) {
      return true
    }
    return false
  }


  function nextButton(nextCursor) {
    if (nextCursor) {
      return false
    } else {
      return true
    }
  }



  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>{`${'Store search'} ${'|'} ${Host?.metaTitle}`}</title>
      </Helmet>
      <div className="sp-style">
        <div className="search-section" style={{ position: 'relative' }}>

          <div className="container">
            <div className="row">

              {!isMobcreen2 &&
                <SeacrhFilter searchCountry={searchCountry} getProducts={getProducts} isFetching={isFetching} />
              }

              <div className="col-md-10 mob-w100 mob-p0" style={{ padding: '5px' }}>
                <div className="row">

                  {isMobcreen2 &&
                    <div className="col-md-12" style={{ padding: '5px' }}>
                      <div>
                        <GetFilterCountries searchCountry={searchCountry} />
                      </div>
                    </div>
                  }

                  {isLoading &&
                    <div className="col-md-12" style={{ padding: '5px' }}>
                      <div className='sp-search-loader'>
                        <div
                          className='sp-query'
                          style={{ fontSize: '1rem', textAlign: 'center', display: 'flex', alignItems: 'center' }}>
                          <span style={{ display: 'flex', alignItems: 'center' }}>
                            <i className='loader-title'>{t('searching_for') + '  ' + 'Warehouse deals'}</i></span>&nbsp;
                          <SearchLoader />
                        </div>

                      </div>
                    </div>
                  }


                  {!isLoading &&
                    <div style={{ width: '100%', padding: '10px 0px 10px 0px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>

                        <div className='search-cardTitle col-md-7' style={{ textAlign: 'start' }}>
                          <div className='search-result-secton'>
                            <div className='sp-query' style={{ display: 'flex', alignItems: 'center', marginTop: 0 }}>
                              <span className='loader-title'>
                                <FlashOnIcon style={{ fontSize: '1.4rem', color: '#fe7f4a' }} /> Warehouse Deals
                              </span>&nbsp;
                              <span style={{ display: 'flex', margin: '0px 5px' }}>
                                {loadFetch() && <div><SearchLoader /></div>}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className='col-md-5'>
                          <div style={{ position: 'relative' }}>
                            <form
                              onSubmit={handleSubmit2(searchOrder)}
                              style={{ maxWidth: '100%' }}
                            >
                              <input
                                style={{ height: '40px', borderRadius: '6px' }}
                                defaultValue={search}
                                type="text"
                                className="form-control"
                                placeholder="Search in deals..."
                                id="orderId"
                                aria-invalid={errors2.orderId ? "true" : "false"}
                                {...register2("orderId", { required: true })}
                              />
                              {!search &&
                                <IconButton
                                  size='sm'
                                  style={{ top: '4px', right: '5px', position: 'absolute', borderRadius: '100px' }}
                                  type="submit"
                                >
                                  <SearchIcon style={{ fontSize: '1.4rem' }} />
                                </IconButton>
                              }
                              {search &&
                                <IconButton
                                  size='sm'
                                  style={{ top: '4px', right: '5px', position: 'absolute', borderRadius: '100px' }}
                                  onClick={(() => clearSearch())}
                                >
                                  <CloseIcon style={{ fontSize: '1.4rem' }} />
                                </IconButton>}
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  {!isLoading &&
                    <>
                      {!isFetching &&
                        <>
                          {getProducts?.length === 0 &&
                            <div className='no-result-found-secton'>
                              <ErrorOutlineOutlinedIcon />
                              <div className='cardTitle'>Looks like we couldn't find what you're searching for.</div>
                            </div>
                          }
                        </>
                      }
                    </>
                  }

                  {getProducts?.map((item, i) =>
                    <div className="col-md-12 cardItem" style={{ padding: '5px' }} key={i}>
                      <Link
                        className="cardItem-item"
                        onClick={(() => addProductImage(item?.image))}
                        to={`/product/${item?.store_id}/${functionIdLink(item?.id, item?.pid, item?.store_id)}/${productTitle(item?.title)}?country=${item?.country}`}
                      >
                        <div className="img-card imgCard">
                          <LazyLoadImage
                            delayTime={100}
                            key={i}
                            alt={item?.title}
                            effect="blur"
                            className="img-item"
                            src={item?.image}
                            onError={handleError}
                            beforeLoad={beforeLoadHandler}
                          />

                          <div className={`delivery-days`}>
                            <span style={{ padding: 0 }} className={isMobcreen ? `badge badge-secondary` : ``}>
                              <BoltOutlinedIcon style={{ fontSize: '1rem', color: '#fe7f4a' }} />
                              Fast Delivery
                            </span>
                          </div>
                          {item?.prices?.deal_value &&
                            <span
                              className='badge badge-danger'
                              style={{ position: 'absolute', left: '5px', top: '5px', zIndex: 111, width: 'auto' }}>
                              <FlashOnIcon style={{ fontSize: '1rem' }} />
                            </span>
                          }
                        </div>
                        <div className="card-content">
                          <div className='title-card' style={{ maxHeight: '45px', minHeight: '45px' }}>
                            <h4>{item?.title?.replace(/[^\w\s.,'/:]/gi, ' ')}</h4>
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', lineHeight: 1 }}>
                            {item?.brand && <div className='brand' style={{ width: '100%' }}>{item?.brand}</div>}
                            {ratingFucn(item?.rating) &&
                              <div className='rating' style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', width: '100%' }}>
                                <span style={{ display: 'flex', alignItems: 'center', color: '#575959', margin: '0px 3px', fontSize: '14px' }}>{item?.rating}</span>
                                <GradeIcon style={{ color: '#fe7f4a', fontSize: '1rem', marginTop: '-1.5px' }} />
                              </div>
                            }
                          </div>

                          <div className="content-item" style={{ padding: 0 }}>
                            <div className='item-price-card'>
                              {Number(item?.prices?.value) === 0 ?
                                <span className='badge badge-secondary'>Check Price</span>
                                :
                                <>
                                  <span className='item-deal-price'>
                                    {formatPrice(item?.prices?.value, item?.prices?.currency, 0)}&nbsp;
                                  </span>
                                  {item?.prices?.deal_value &&
                                    <span className='item-price'>
                                      <small className='mobiel-size' style={{ textDecoration: 'line-through', color: '#828282' }}>
                                        {formatPrice(item?.prices?.price, item?.prices?.currency, 0)}
                                      </small>
                                    </span>
                                  }
                                </>
                              }
                            </div>
                          </div>
                          <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                            {/* <span className='item-price mobiel-size'>
                              {item?.prices?.discount ?
                                <span className='badge badge-danger'>{`-${item?.prices?.discount}%`}</span> : ``}
                            </span> */}
                            {loadCountrySkeleton(isFetching, searchCountry, item.country) ?
                              <Skeleton style={{ height: '22px', width: '30%' }} /> :
                              <div style={{ display: 'flex', alignItems: 'center', fontSize: '12px', color: '#575959' }}>
                                {t('From')}&nbsp;
                                <img
                                  style={{ width: '20px', objectFit: 'contain' }}
                                  loading="lazy"
                                  src={`https://flagcdn.com/w20/${item?.country?.toLowerCase()}.png`}
                                  srcSet={`https://flagcdn.com/w40/${item?.country?.toLowerCase()}.png 2x`}
                                  alt=""
                                />&nbsp;
                                <div style={{ color: '#575959' }}>{ProductCountries(item?.country)}</div>
                              </div>
                            }
                          </div>
                        </div>
                      </Link>
                    </div>
                  )}

                  {loadFetch() &&
                    <LoadMoreSkeleton />
                  }

                </div>
                <br />
              </div>

              {getProducts?.length > 0 &&
                <div className='search-paginattion' style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                  <div style={{ alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
                    <Button
                      style={{ border: '0.5px solid #39414a', color: '#39414a', fontWeight: 400, height: '40px', margin: '0px 10px' }}
                      disabled={isFetching || (nextButton(pagination?.nextCursor))}
                      variant='outlined'
                      onClick={loadMore}
                    >
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span>{loadFetch() ? 'Loading' : t('load_more')}</span>
                        {loadFetch() && <span style={{ margin: '0px 10px' }}><Loader /></span>}
                      </div>
                    </Button>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
        <br />
        <br />
      </div >
    </>
  );
}

export default StoreDeals;
